var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommaDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 0.3125L27.7188 1C27.3438 2.52083 26.8542 4.14583 26.25 5.875C25.6458 7.58333 25 9.30208 24.3125 11.0312C23.625 12.7604 22.9271 14.4062 22.2188 15.9688H15.375C15.7708 14.2812 16.1667 12.5104 16.5625 10.6562C16.9583 8.80208 17.3229 6.97917 17.6562 5.1875C18.0104 3.39583 18.2917 1.77083 18.5 0.3125H27.25ZM12.6875 0.3125L13.125 1C12.75 2.52083 12.2604 4.14583 11.6562 5.875C11.0729 7.58333 10.4271 9.30208 9.71875 11.0312C9.03125 12.7604 8.33333 14.4062 7.625 15.9688H0.78125C1.07292 14.7188 1.36458 13.4062 1.65625 12.0312C1.96875 10.6562 2.26042 9.28125 2.53125 7.90625C2.82292 6.53125 3.08333 5.19792 3.3125 3.90625C3.54167 2.61458 3.73958 1.41667 3.90625 0.3125H12.6875Z",
    fill: "#83BA01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommaDown);
export default __webpack_public_path__ + "static/media/comma_down.51a56522dca6146691f79e8d3610250f.svg";
export { ForwardRef as ReactComponent };